import Vue from 'vue'
import countryFlag from 'vue-country-flags'

Vue.use(countryFlag)
